import { lazy } from "react";

/**
 * Lazy-loaded components for different forms used in the application.
 */
export const AdminLoginForm = lazy(() => import("./Login/index.form"));
export const AdminForgotPasswordForm = lazy(() =>
  import("./ForgotPassword/index.form")
);
export const ResetPasswordForm = lazy(() =>
  import("./ResetPassword/index.form")
);
export const AdminUpdateProfileForm = lazy(() =>
  import("./UpdateProfile/index.form")
);
export const AdminChangePasswordForm = lazy(() =>
  import("./ChangePassword/index.form")
);
export const AdminVerificationForm = lazy(() =>
  import("./OtpVerification/index.form")
);
export const PandingQueriesForm = lazy(() =>
  import("./ManageQueries/PendingQuery/index.form")
);

export const MasterFilterForm = lazy(() =>
  import("./MasterFilterForm/index.form")
);
export const ClaimTypeForm = lazy(() =>
  import("./Master/ClaimType/index.form")
);

export const NotificationForm = lazy(() =>
  import("./NotificationForm/index.form")
);

export const SupportForm = lazy(() =>
  import("./SupportForm/index.form")
);
export const NotificationLinkForm = lazy(() => import("./ManageNotificationLink/index.form"));
// Additional exports
export * from "./ManageCms";
export * from "./UserDetailForm";
export { default as ManageRoleForm } from "./ManageRole/index.form";
